import React from 'react';
import './styles.css'

class Card extends React.Component {
    render() {
        return (
            <div style={this.props.style} className={'bg-white p-6 rounded-lg shadow-md mb-8 ' + this.props.className}>
                {this.props.title !== undefined ?
                  <h2 class="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
                  <i class="fas fa-ticket-alt mr-4 text-indigo-600"></i> {this.props.title}
              </h2>
              
                    : null
                }
                <div className={!this.props.noPadding ? 'p-1' : ''}>
                    {this.props.children}
                </div>
                {this.props.footer !== undefined ?
                    <div className='card-footer'>
                        {this.props.footer}
                    </div>
                    : null
                }
            </div>
        )
    }

}

export default Card;